import React from 'react'
import { Box, Button } from '@mui/material'
import { Link,useNavigate } from 'react-router-dom'
import Sliceimg from '../assets/Slice.png'
import mobiimg from "../assets/mobil.png"
import useMediaQuery from '@mui/material/useMediaQuery';

const HeroSection = ({ title }) => {
    const matches = useMediaQuery('(max-width:500px)');
    const navigate = useNavigate();

  const handleClick = () => {
  navigate('/', {state:{ fromAboutUs: true} });
  };
    return (
        <>
            <Box className="Hero_main" style={{backgroundImage:matches ?`url(${mobiimg})`:`url(${Sliceimg})`,height:matches ?'100vh':'120vh'}} >
                <Box className="hero_div">
                    <h1 className='herotitle'>
                        {title.title}
                    </h1>
                    {/* <Link> */}
                        <Button variant="contained" className='herobtn1' onClick={handleClick}>
                        WeCare Plans
                        </Button>
                    {/* </Link> */}
                </Box>
            </Box>
        </>
    )
}

export default HeroSection
